// Interfaces should be moved to a separate file when refactoring PolygonDrawing.js to TSX in the future

import { DRAWING_MODES } from '../PolygonDrawing/PolygonDrawingContext';

export interface PolygonDrawingLang {
  drawNote: string;
  drawField: string;
  placeMarker: string;
  drawInnerBoundary: string;
  editFieldBoundaries: string;
  editFieldBoundariesMessage: string;
  splitField: string;
  split: string;
  drawPolygon: string;
  save: string;
  add: string;
  clickMap: string;
}

export interface MergeFieldConfirmationPopoverLang {
  title: string;
  message: string;
}

export interface LangFile {
  PolygonDrawing: PolygonDrawingLang;
  MergeFieldConfirmationPopover: MergeFieldConfirmationPopoverLang;
}

export interface MagicWand {
  isSelecting: boolean;
}

export interface PopoverProps {
  LangFile: LangFile;
  magicWand?: MagicWand;
  isDrawingField?: boolean;
  isDrawingNote?: boolean;
  isPlacingMarker?: boolean;
  isDrawingFieldHole?: boolean;
  isEditingFieldBoundaries?: boolean;
  isSplittingField?: boolean;
  isEditingMergedField?: boolean;
}

export type DrawingMode =
  | 'FIELD'
  | 'NOTE'
  | 'SELECT'
  | 'FIELD_HOLE'
  | 'EDIT_FIELD_BOUNDARIES'
  | 'SPLIT_FIELD'
  | 'SPLIT_FIELD_POLYGONS'
  | 'EDIT_MERGED_FIELD';

export const getPopoverTitle = (props: PopoverProps): string => {
  const { LangFile, magicWand } = props;
  if (magicWand?.isSelecting) return LangFile.PolygonDrawing.drawNote;
  if (props.isDrawingField) return LangFile.PolygonDrawing.drawField;
  if (props.isDrawingNote) return LangFile.PolygonDrawing.drawNote;
  if (props.isPlacingMarker) return LangFile.PolygonDrawing.placeMarker;
  if (props.isDrawingFieldHole) return LangFile.PolygonDrawing.drawInnerBoundary;
  if (props.isEditingFieldBoundaries) return LangFile.PolygonDrawing.editFieldBoundaries;
  if (props.isSplittingField) return LangFile.PolygonDrawing.splitField;
  if (props.isEditingMergedField) return LangFile.MergeFieldConfirmationPopover.title;
  return '';
};

export const getPopoverMessage = (props: PopoverProps): string => {
  const { LangFile, magicWand } = props;
  if (props.isPlacingMarker) return LangFile.PolygonDrawing.clickMap;
  if (magicWand?.isSelecting) return LangFile.PolygonDrawing.clickMap;
  if (props.isEditingFieldBoundaries) return LangFile.PolygonDrawing.editFieldBoundariesMessage;
  if (props.isSplittingField) return LangFile.PolygonDrawing.drawPolygon;
  if (props.isEditingMergedField) return LangFile.MergeFieldConfirmationPopover.message;
  return LangFile.PolygonDrawing.drawPolygon;
};

export const getPopoverActionText = (props: PopoverProps, drawingMode: DrawingMode): string => {
  const { LangFile } = props;
  if (props.isSplittingField && drawingMode === DRAWING_MODES.SPLIT_FIELD)
    return LangFile.PolygonDrawing.split;
  if (props.isSplittingField && drawingMode === DRAWING_MODES.SPLIT_FIELD_POLYGONS)
    return LangFile.PolygonDrawing.save;
  if (props.isEditingFieldBoundaries) return LangFile.PolygonDrawing.save;
  if (props.isEditingMergedField) return LangFile.PolygonDrawing.save;
  return LangFile.PolygonDrawing.add;
};
